import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { questionsData } from '../../survey/questionsData';
import steps from '../../survey/steps';
import buildConfig from '../../survey/buildConfig';
import questions from '../../survey/questions';
import focusFix from '../../utils/scripts/focusFix';
import * as configs from '../../survey/configs';

function OnlyOneOption(props) {
  const dispatch = useDispatch();
  const initialAge = useSelector((state) => state.global.initialAge);
  const config = useSelector((state) => state.steps.config);
  const configToApply = (config && config in configs) ? configs[config] : configs.defaultConfig;
  const ref = useRef(null);

  function checkIfOptionSelected() {
    const check = questions.isAnswerSelected({
      questionName: props.questionName,
      answer: props.option.value,
    });

    return check;
  }

  function chooseAnswer() {
    if (props.questionName === 'age' && initialAge !== props.option.value) {
      dispatch({
        type: 'SET_AGE',
        payload: props.option.value,
      });

      questions.setup({
        questionsData,
      });

      focusFix();

      steps.setup({
        stepsConfig: buildConfig({ config: configToApply, configName: config, age: props.option.value }),
        currentStep: 'age',
        stepsDetails: configs.stepsDetails,
      });
    }

    if (props.questionName === 'role') {
      const roleHandler = (props.option.value === 'dog' || props.option.value === 'puppy')
        ? 'haveDog'
        : props.option.value;

      dispatch({
        type: 'SET_ROLE',
        payload: roleHandler,
      });

      questions.setup({
        questionsData,
      });

      focusFix();

      steps.setup({
        stepsConfig: buildConfig({ config: configToApply, configName: config, role: roleHandler }),
        currentStep: 'role',
        stepsDetails: configs.stepsDetails,
      });
    }

    if (props.questionName === 'customV2_age_v2' || props.questionName === 'start_page_age' || props.questionName === 'start_page_age_v2' || props.questionName === 'start_page_age_v3') {
      questions.addOnlyAnswer({
        questionName: 'customV2_age',
        answer: props.option,
      });
      questions.addOnlyAnswer({
        questionName: props.questionName,
        answer: props.option,
      });
    } else {
      questions.addOnlyAnswer({
        questionName: props.questionName,
        answer: props.option,
      });
    }

    if (props.questionName !== 'customV2_reason' && !props.showBottomBar) {
      props.actionOnClick();
    }
  }

  return (
    <button
      type="button"
      ref={ref}
      className={`${props.className} ${checkIfOptionSelected() ? (props.selectedStateClass) : ''}`}
      onClick={() => {
        chooseAnswer();
        props.runOnChoose && props.runOnChoose();
      }}
      tabIndex={props.disableFromFocus ? -1 : ''}
    >
      {props.children}
    </button>
  );
}

export default OnlyOneOption;
